import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import {
  Box,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Pagination,
  Tooltip,
} from '@mui/material';
import { isNil } from 'lodash';
import { useId } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import type { OrderActionsLog } from 'models/orderActionsLog';
import type { FC } from 'react';
import type { PaginatedList } from 'services/dtoModels/paginatedList';

const OrdersWithoutDateList: FC<OrdersWithoutDateListProps> = ({
  data,
  onPageChange,
}) => {
  const componentId = useId();

  if (isNil(data) || data.items.length === 0) {
    return null;
  }

  return (
    <>
      <List disablePadding dense>
        {data.items.map((item) => {
          const orderPath = `/orders/${item.order.id}`;

          return (
            <ListItem
              key={`${componentId}-${item.id}`}
              disablePadding
              divider
              disableGutters
              secondaryAction={
                <Tooltip title='Перейти к заказу'>
                  <IconButton
                    component={RouterLink}
                    to={`${orderPath}/actions`}
                    size='small'
                    edge='end'
                    aria-label='Перейти к заказу'>
                    <OpenInNewIcon fontSize='inherit' />
                  </IconButton>
                </Tooltip>
              }>
              <ListItemText
                primary={`Заказ ${item.order.number}`}
                secondary={item.order.client.fullName}
                secondaryTypographyProps={{
                  variant: 'caption',
                }}
              />
            </ListItem>
          );
        })}
      </List>
      {data.totalPages > 1 && (
        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
          <Pagination
            count={data.totalPages}
            page={data.pageIndex + 1}
            size='small'
            hidePrevButton
            variant='outlined'
            color='primary'
            hideNextButton
            onChange={(_, value) => {
              onPageChange(value - 1);
            }}
          />
        </Box>
      )}
    </>
  );
};

export interface OrdersWithoutDateListProps {
  data?: PaginatedList<OrderActionsLog>;
  onPageChange: (page: number) => void;
}

export default OrdersWithoutDateList;
